import { MarchVoucher } from 'components/common/MarchPromo/types'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { formatPrice } from 'helpers/helpers'
import { AddedVoucherInfoTileContainer } from './styles'

export const AddedVoucherInfoTile = ({
    voucher,
}: {
    voucher: MarchVoucher
}) => (
    <AddedVoucherInfoTileContainer>
        <Text className="name" variant="body" color="grayscale_800">
            {voucher.firstName} {voucher.lastName}
        </Text>
        <Box
            className="details"
            direction="row"
            gap={[8, 16]}
            align="center"
            wrap={'wrap'}
        >
            <Text variant="bodySmall" color="grayscale_900">
                {voucher.tickets[0].person}
            </Text>
            <div className="orange-dot" />
            <Text variant="bodySmall" color="grayscale_900">
                {voucher.tickets[0].zone}
            </Text>
            <div className="orange-dot" />
            <Text variant="bodySmall" color="grayscale_900">
                {voucher.tickets[0].ticketType}
            </Text>
        </Box>
        <Text className="price" variant="bodySmallStrong" color="secondary_500">
            {voucher.tickets.length > 1 ? `${voucher.tickets.length} x` : ''}{' '}
            {voucher.price ? `${formatPrice(voucher.price)} PLN` : '0 PLN'}
        </Text>
    </AddedVoucherInfoTileContainer>
)
